import { createFileRoute } from '@tanstack/react-router'
import { ScBudgetPage } from '@/features/support-coordination/budget'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/budget',
)({
  component: ScBudgetPage,
})
